import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";

import auth from "./auth";
import user from "./user";
import datosEmergencia from "./datosEmergencia";
import documents from "./documents";
import features from "./features";

const reducers = combineReducers({
  auth,
  user,
  datosEmergencia,
  documents,
  features,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "user"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

// PLAN-004 Phase 1.6: Use RTK default middleware (includes thunk) with
// redux-persist serializable check exceptions
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
export let persistor = persistStore(store);
